export const getRouterPaths = (role) => {
  const basePath = role === "Admin" ? "/admin" : "";
  const landsPath = role === "Admin" ? "lands" : "userLands";

  return {
    login: "/login",
    initialPasswordChange: "/initial-password-change",
    home: `${basePath}/home`,
    users: `${basePath}/users`,
    addUsers: `${basePath}/users/addUser`,
    lands: `${basePath}/lands`,
    fieldsType: `${basePath}/fieldsType`,
    settings: `${basePath}/settings`,
    profile: `${basePath}/profile`,
    userLands: `${basePath}/userLands`,
    cultureList: `${basePath}/cultureList`,
    irrigationType: `${basePath}/irrigationType`,
    addCulture: `${basePath}/cultureList/addCulture`,
    updateCulture: `${basePath}/cultureList/updateCulture`,
    updateUser: `${basePath}/users/updateUser`,
    addIrrigation: `${basePath}/irrigationType/addIrrigation`,
    updateIrrigation: `${basePath}/irrigationType/updateIrrigation`,
    addFieldType: `${basePath}/fieldsType/addFieldType`,
    updateFieldType: `${basePath}/fieldsType/updateFieldType`,
    addField: `${basePath}/userLands/addField`,
    field: `${basePath}/userLands`,
    updateField: `${basePath}/${landsPath}/updateField`,
    tools: `${basePath}/tools`,
    addTool: `${basePath}/tools/addTool`,
    fieldNotebook: `${basePath}/fieldNotebook`,
    updateTool: `${basePath}/tools/updateTool`,
    toolRequest: `${basePath}/toolRequest`,
    monitoringSection: "/monitoring",
    forgotPassword: "/forgotPassword",
    changePassword: "/changePassword",
    resetPassword: "/reset-password",
    addNote: `${basePath}/fieldNotebook/addNote`,
    digitalTwin: `${basePath}/digitalTwin`,
    cropDetail: `${basePath}/digitalTwin/cropDetail`,
  };
};
